import { useAtomValue } from 'jotai';
import { filtersToPersistAtom } from '@/atoms/filters/persistedFilters';
import { playerIdAtom } from '@/atoms/player/player';
import { playerEventsForMetricCountAtom } from '@/atoms/queries/player/playerEventData';
import { PlayerPreviewEvents } from '@/components/player/radar/preview/PlayerPreviewEvents';
import { EntityMetricPreviewPanel } from '@/components/preview/EntityMetricPreviewPanel';
import { playerPitchVisComponents } from '@/consts/visualisationComponents';

const PlayerEventMap = playerPitchVisComponents.eventMap;

export const PlayerPrimaryPreviewPanel = () => {
  const playerId = useAtomValue(playerIdAtom);
  const filters = useAtomValue(filtersToPersistAtom);

  return (
    <EntityMetricPreviewPanel
      pathTo={`../../../player/${playerId}/vis`}
      eventsForMetricCountAtom={playerEventsForMetricCountAtom}
      filtersToHydrate={filters}
      eventMap={<PlayerEventMap isPreview />}
    >
      <PlayerPreviewEvents />
    </EntityMetricPreviewPanel>
  );
};
